/**
 * Foundation/Core — Notification severity taxonomy
 *
 * Tassonomia condivisa da tutti i Product Pack della Gruppo Impresa Suite per
 * classificare la gravita' di una notifica.
 *
 *   info      → informativa (verde) — nessuna azione richiesta
 *   warning   → attenzione (ambra)  — azione consigliata a breve
 *   critical  → critica (rosso)     — azione richiesta subito
 */
export const SEVERITY_META = {
  info:     { label: "Informativa", tone: "info",     hex: "#0F766E", dot: "bg-emerald-600" },
  warning:  { label: "Attenzione",  tone: "warning",  hex: "#B45309", dot: "bg-amber-500" },
  critical: { label: "Critica",     tone: "critical", hex: "#B91C1C", dot: "bg-red-600" },
};

/** Chiavi delle severity supportate (utile per validazione lato Product Pack). */
export const SEVERITY_KEYS = Object.freeze(Object.keys(SEVERITY_META));

/**
 * Risolve la severity dato un key. Fallback su `info` per robustezza.
 * Utility 100% agnostica: nessuna conoscenza di kind, moduli o Product Pack.
 */
export function resolveSeverity(key) {
  const k = SEVERITY_META[key] ? key : "info";
  return { key: k, ...SEVERITY_META[k] };
}
